import { dataTransferWrap } from '../dataTransferService'
import { ModulesMap } from '@/config/data/modulesMaps'
import dtConfig from '@/config/data-transfer'

function registerUser(payload) {
    return dataTransferWrap(ModulesMap.AUTH, dtConfig[ModulesMap.AUTH].registerUser, payload)
}

function loginUser(payload) {
    return dataTransferWrap(ModulesMap.AUTH, dtConfig[ModulesMap.AUTH].loginUser, payload)
}

function resendEmailConfirmation(payload) {
    return dataTransferWrap(ModulesMap.AUTH, dtConfig[ModulesMap.AUTH].resendEmailConfirmation, payload)
}

export default {
    registerUser,
    loginUser,
    resendEmailConfirmation
}